import type { DownloadTreeNode } from '~/types/download'
import { nextTick } from 'vue'
import { findTocNodeIdBySelectionKey } from '~/utils/download/treeSelection'

export function useDownloadTocScroll() {
  function scrollToTocNode(nodeId: string) {
    const el = document.getElementById(`toc-${nodeId}`)
    if (!el) {
      return
    }

    const scrollContainer = el.closest('ul.overflow-y-auto') as HTMLElement | null
    if (!scrollContainer) {
      el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      return
    }

    const containerRect = scrollContainer.getBoundingClientRect()
    const elementRect = el.getBoundingClientRect()
    const currentScrollTop = scrollContainer.scrollTop

    const elementTopInContainer = elementRect.top - containerRect.top + currentScrollTop
    const topPadding = 24
    const targetScrollTop = Math.max(0, elementTopInContainer - topPadding)

    scrollContainer.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth',
    })
  }

  function scrollToSelectionKey(nodes: DownloadTreeNode[], key: string | null) {
    if (!key) {
      return
    }

    const tocNodeId = findTocNodeIdBySelectionKey(nodes, key)
    if (!tocNodeId) {
      return
    }

    nextTick(() => {
      scrollToTocNode(tocNodeId)
      setTimeout(() => scrollToTocNode(tocNodeId), 120)
    })
  }

  return {
    scrollToTocNode,
    scrollToSelectionKey,
  }
}
